module.exports = __webpack_public_path__ + "bdf5d473c23587b19606b1a3eace980a.pdf";